/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeRectVIcon16Light } from './ShapeRectVIcon16Light';
import { ShapeRectVIcon16Regular } from './ShapeRectVIcon16Regular';
import { ShapeRectVIcon16Solid } from './ShapeRectVIcon16Solid';
import { ShapeRectVIcon20Light } from './ShapeRectVIcon20Light';
import { ShapeRectVIcon20Regular } from './ShapeRectVIcon20Regular';
import { ShapeRectVIcon20Solid } from './ShapeRectVIcon20Solid';
import { ShapeRectVIcon24Regular } from './ShapeRectVIcon24Regular';
import { ShapeRectVIcon24Solid } from './ShapeRectVIcon24Solid';
import { ShapeRectVIcon32Regular } from './ShapeRectVIcon32Regular';
import { ShapeRectVIcon64Regular } from './ShapeRectVIcon64Regular';
var sizes = {
    16: {
        light: ShapeRectVIcon16Light,
        regular: ShapeRectVIcon16Regular,
        solid: ShapeRectVIcon16Solid,
    },
    20: {
        light: ShapeRectVIcon20Light,
        regular: ShapeRectVIcon20Regular,
        solid: ShapeRectVIcon20Solid,
    },
    24: {
        regular: ShapeRectVIcon24Regular,
        solid: ShapeRectVIcon24Solid,
    },
    32: {
        regular: ShapeRectVIcon32Regular,
    },
    64: {
        regular: ShapeRectVIcon64Regular,
    },
};
export var ShapeRectVIcon = forwardRef('ShapeRectVIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
